import { IsoDocument } from '@bechtel/types';
export interface ISOPreviewProps {
  url: IsoDocument['url'];
}
